import { SvgIconProps, Theme, alpha, buttonClasses } from '@mui/material'
import { C1Button, C1ButtonColorType, C1ButtonProps } from 'c1ui'
import { sxc } from 'components/no-ui/styles/styleTypes'
import React, { FC } from 'react'

type C1IconButtonBaseProps = Omit<C1ButtonProps, 'variant' | 'color'> & {
    size?: 'small' | 'medium';
    children: React.ReactElement<SvgIconProps>;
    'aria-label': string;
};

type OutlinedIconButtonProps = {
    variant: 'outlined';
    color?: C1ButtonColorType;
};

type TextIconButtonProps = {
    variant?: 'text'; // default variant can be undefined or 'text'
    color?: 'inherit';
};

export type C1IconButtonProps =
    & C1IconButtonBaseProps
    & (OutlinedIconButtonProps | TextIconButtonProps)

const overridesSx = {
    [`&.${buttonClasses.outlinedSuccess}`]: {
        '&:hover': {
            borderColor: (t: Theme): string => alpha(t.palette.success.dark, 0.5),
            color: 'success.dark',
        },
    },
    [`&.${buttonClasses.outlinedError}`]: {
        '&:hover': {
            borderColor: (t: Theme): string => alpha(t.palette.error.dark, 0.5),
            color: 'error.dark',
        },
    },
    [`&.${buttonClasses.textPrimary}`]: {
        color: 'text.secondary',
        '&:hover': {
            color: 'primary.main',
            backgroundColor: 'primary.extraLight',
        },
    },
    [`&.${buttonClasses.disabled}`]: {
        color: 'grey.400',
        backgroundColor: 'grey.200',
        border: 'none',
    },
}

export const C1IconButton: FC<C1IconButtonProps> = ({ children, size = 'small', sx, color = 'primary', variant = 'text', ...props }) => {
    const icon = React.cloneElement(children, { fontSize: size })
    const iconSx = {
        ...overridesSx,
        minWidth: 0,
        padding: size === 'medium'
            ? variant === 'outlined' ? '2px' : '3px'
            : variant === 'outlined' ? '6px' : '7px',
    }

    return (<C1Button sx={sxc(iconSx, sx)} variant={variant} color={color} {...props}>{icon}</C1Button>)
}
